require('./broadcastStatusListService');

"use strict";

angular.module('app.broadcastStatus.broadcastStatusController', [
    'app.broadcastStatus.broadcastStatusListService'
])
    .controller('app.broadcastStatus.broadcastStatusController', [
        '$scope',
        'app.broadcastStatus.broadcastStatusListService',
        'PRODUCT',
        function ($scope, broadcastStatusList, product) {

        	$scope.productName = product.Name;

            $scope.broadcastStatusList = broadcastStatusList;

            broadcastStatusList.retrieve();
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/broadcastStatus/broadcastStatusController.js